/* tslint:disable */
/* eslint-disable */
/**
 * Commerce Webservices
 * Manages all of the common commerce functionality, and also includes customizations from installed AddOns. The implementing extension is called commercewebservices.
 *
 * The version of the OpenAPI document: 2.2.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ErrorList,
  Principal,
  ReplaceLoginIdInput,
  ReplacePasswordInput,
  User,
  UserGroupList,
  UserSignUp,
} from '../models';
import {
    ErrorListFromJSON,
    ErrorListToJSON,
    PrincipalFromJSON,
    PrincipalToJSON,
    ReplaceLoginIdInputFromJSON,
    ReplaceLoginIdInputToJSON,
    ReplacePasswordInputFromJSON,
    ReplacePasswordInputToJSON,
    UserFromJSON,
    UserToJSON,
    UserGroupListFromJSON,
    UserGroupListToJSON,
    UserSignUpFromJSON,
    UserSignUpToJSON,
} from '../models';

export interface ChangeUserLoginIdRequest {
    baseSiteId: string;
    userId: string;
    replaceLoginIdInput: ReplaceLoginIdInput;
    sapCommerceCloudCustomerId?: string;
}

export interface ChangeUserPasswordRequest {
    baseSiteId: string;
    userId: string;
    replacePasswordInput: ReplacePasswordInput;
    sapCommerceCloudCustomerId?: string;
}

export interface CreateUserRequest {
    baseSiteId: string;
    userSignUp: UserSignUp;
    fields?: string;
    sapCommerceCloudCaptchaToken?: string;
    sapCommerceCloudCustomerId?: string;
}

export interface GetCustomerByCustomerIdRequest {
    baseSiteId: string;
    customerId: string;
    fields?: string;
    sapCommerceCloudCustomerId?: string;
}

export interface GetUserRequest {
    baseSiteId: string;
    userId: string;
    fields?: string;
    sapCommerceCloudCustomerId?: string;
}

export interface GetUserCustomerGroupsRequest {
    baseSiteId: string;
    userId: string;
    fields?: string;
    sapCommerceCloudCustomerId?: string;
}

export interface RemoveUserRequest {
    baseSiteId: string;
    userId: string;
    sapCommerceCloudCustomerId?: string;
}

export interface ReplaceUserRequest {
    baseSiteId: string;
    userId: string;
    user: User;
    sapCommerceCloudCustomerId?: string;
}

export interface ReplaceUserLoginRequest {
    baseSiteId: string;
    newLogin: string;
    password: string;
    userId: string;
    sapCommerceCloudCustomerId?: string;
}

export interface ReplaceUserPasswordRequest {
    baseSiteId: string;
    _new: string;
    old: string;
    userId: string;
    sapCommerceCloudCustomerId?: string;
}

export interface UpdateUserRequest {
    baseSiteId: string;
    userId: string;
    user: User;
    sapCommerceCloudCustomerId?: string;
}

/**
 * UsersApi - interface
 * 
 * @export
 * @interface UsersApiInterface
 */
export interface UsersApiInterface {
    /**
     * Changes a customer\'s login id. Requires the customer\'s current password. This endpoint is added in the 2211.23 update.
     * @summary Changes customer\'s login id.
     * @param {string} baseSiteId Base site identifier
     * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
     * @param {ReplaceLoginIdInput} replaceLoginIdInput 
     * @param {string} [sapCommerceCloudCustomerId] Default B2B Unit of the B2B customer to be used during the request.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApiInterface
     */
    changeUserLoginIdRaw(requestParameters: ChangeUserLoginIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Changes a customer\'s login id. Requires the customer\'s current password. This endpoint is added in the 2211.23 update.
     * Changes customer\'s login id.
     */
    changeUserLoginId(requestParameters: ChangeUserLoginIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Updates the password of a customer. This endpoint is added in the 2211.23 update.
     * @summary Updates the password of a customer.
     * @param {string} baseSiteId Base site identifier
     * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
     * @param {ReplacePasswordInput} replacePasswordInput 
     * @param {string} [sapCommerceCloudCustomerId] Default B2B Unit of the B2B customer to be used during the request.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApiInterface
     */
    changeUserPasswordRaw(requestParameters: ChangeUserPasswordRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Updates the password of a customer. This endpoint is added in the 2211.23 update.
     * Updates the password of a customer.
     */
    changeUserPassword(requestParameters: ChangeUserPasswordRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Registers a customer. Requires the following parameters: login, password, firstName, lastName, titleCode, verificationTokenId, verificationTokenCode. Only when OTP for registration is enabled, verificationTokenId and verificationTokenCode are required.
     * @summary  Registers a customer.
     * @param {string} baseSiteId Base site identifier
     * @param {UserSignUp} userSignUp 
     * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC,DEFAULT,FULL
     * @param {string} [sapCommerceCloudCaptchaToken] The user\&#39;s response token returned by captcha provider. When the captchaCheckEnabled &#x3D; true for the store, the field is mandatory and will call the provider to validate.
     * @param {string} [sapCommerceCloudCustomerId] Default B2B Unit of the B2B customer to be used during the request.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApiInterface
     */
    createUserRaw(requestParameters: CreateUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<User>>;

    /**
     * Registers a customer. Requires the following parameters: login, password, firstName, lastName, titleCode, verificationTokenId, verificationTokenCode. Only when OTP for registration is enabled, verificationTokenId and verificationTokenCode are required.
     *  Registers a customer.
     */
    createUser(requestParameters: CreateUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<User>;

    /**
     * Retrieve the customer information by customer id.
     * @summary Retrieve the customer information by customer id.
     * @param {string} baseSiteId Base site identifier
     * @param {string} customerId 
     * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC,DEFAULT,FULL
     * @param {string} [sapCommerceCloudCustomerId] Default B2B Unit of the B2B customer to be used during the request.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApiInterface
     */
    getCustomerByCustomerIdRaw(requestParameters: GetCustomerByCustomerIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Principal>>;

    /**
     * Retrieve the customer information by customer id.
     * Retrieve the customer information by customer id.
     */
    getCustomerByCustomerId(requestParameters: GetCustomerByCustomerIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Principal>;

    /**
     * Retrieves detailed information about a specific user\'s profile.
     * @summary Retrieves the customer profile.
     * @param {string} baseSiteId Base site identifier
     * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
     * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC,DEFAULT,FULL
     * @param {string} [sapCommerceCloudCustomerId] Default B2B Unit of the B2B customer to be used during the request.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApiInterface
     */
    getUserRaw(requestParameters: GetUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<User>>;

    /**
     * Retrieves detailed information about a specific user\'s profile.
     * Retrieves the customer profile.
     */
    getUser(requestParameters: GetUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<User>;

    /**
     * Retrieves a list of customer groups that a specific user belongs to.
     * @summary Retrieves the customer groups.
     * @param {string} baseSiteId Base site identifier
     * @param {string} userId User identifier.
     * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC,DEFAULT,FULL
     * @param {string} [sapCommerceCloudCustomerId] Default B2B Unit of the B2B customer to be used during the request.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApiInterface
     */
    getUserCustomerGroupsRaw(requestParameters: GetUserCustomerGroupsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UserGroupList>>;

    /**
     * Retrieves a list of customer groups that a specific user belongs to.
     * Retrieves the customer groups.
     */
    getUserCustomerGroups(requestParameters: GetUserCustomerGroupsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UserGroupList>;

    /**
     * Deletes the customer profile associated with the user identifier.
     * @summary Deletes the customer profile.
     * @param {string} baseSiteId Base site identifier
     * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
     * @param {string} [sapCommerceCloudCustomerId] Default B2B Unit of the B2B customer to be used during the request.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApiInterface
     */
    removeUserRaw(requestParameters: RemoveUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Deletes the customer profile associated with the user identifier.
     * Deletes the customer profile.
     */
    removeUser(requestParameters: RemoveUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Updates customer profile. Attributes not provided in the request body will be defined again (set to null or default).
     * @summary Updates the customer profile.
     * @param {string} baseSiteId Base site identifier
     * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
     * @param {User} user 
     * @param {string} [sapCommerceCloudCustomerId] Default B2B Unit of the B2B customer to be used during the request.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApiInterface
     */
    replaceUserRaw(requestParameters: ReplaceUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Updates customer profile. Attributes not provided in the request body will be defined again (set to null or default).
     * Updates the customer profile.
     */
    replaceUser(requestParameters: ReplaceUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Changes a customer\'s login name. Requires the customer\'s current password. This endpoint is deprecated in the 2211.23 update and its deletion is planned. Please use the POST /{baseSiteId}/users/{userId}/login instead.
     * @summary Changes customer\'s login name.
     * @param {string} baseSiteId Base site identifier
     * @param {string} newLogin New login name of a customer. The name is case insensitive.
     * @param {string} password Current password of a customer.
     * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
     * @param {string} [sapCommerceCloudCustomerId] Default B2B Unit of the B2B customer to be used during the request.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof UsersApiInterface
     */
    replaceUserLoginRaw(requestParameters: ReplaceUserLoginRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Changes a customer\'s login name. Requires the customer\'s current password. This endpoint is deprecated in the 2211.23 update and its deletion is planned. Please use the POST /{baseSiteId}/users/{userId}/login instead.
     * Changes customer\'s login name.
     */
    replaceUserLogin(requestParameters: ReplaceUserLoginRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Updates the password of a customer. This endpoint is deprecated in the 2211.23 update and its deletion is planned. Please use the POST /{baseSiteId}/users/{userId}/password instead.
     * @summary Updates the password of a customer.
     * @param {string} baseSiteId Base site identifier
     * @param {string} _new New password.
     * @param {string} old Old password.
     * @param {string} userId User identifier.
     * @param {string} [sapCommerceCloudCustomerId] Default B2B Unit of the B2B customer to be used during the request.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof UsersApiInterface
     */
    replaceUserPasswordRaw(requestParameters: ReplaceUserPasswordRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Updates the password of a customer. This endpoint is deprecated in the 2211.23 update and its deletion is planned. Please use the POST /{baseSiteId}/users/{userId}/password instead.
     * Updates the password of a customer.
     */
    replaceUserPassword(requestParameters: ReplaceUserPasswordRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Updates customer profile. Only attributes provided in the request body will be changed.
     * @summary Updates customer profile
     * @param {string} baseSiteId Base site identifier
     * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
     * @param {User} user 
     * @param {string} [sapCommerceCloudCustomerId] Default B2B Unit of the B2B customer to be used during the request.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApiInterface
     */
    updateUserRaw(requestParameters: UpdateUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Updates customer profile. Only attributes provided in the request body will be changed.
     * Updates customer profile
     */
    updateUser(requestParameters: UpdateUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

}

/**
 * 
 */
export class UsersApi extends runtime.BaseAPI implements UsersApiInterface {

    /**
     * Changes a customer\'s login id. Requires the customer\'s current password. This endpoint is added in the 2211.23 update.
     * Changes customer\'s login id.
     */
    async changeUserLoginIdRaw(requestParameters: ChangeUserLoginIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.baseSiteId === null || requestParameters.baseSiteId === undefined) {
            throw new runtime.RequiredError('baseSiteId','Required parameter requestParameters.baseSiteId was null or undefined when calling changeUserLoginId.');
        }

        if (requestParameters.userId === null || requestParameters.userId === undefined) {
            throw new runtime.RequiredError('userId','Required parameter requestParameters.userId was null or undefined when calling changeUserLoginId.');
        }

        if (requestParameters.replaceLoginIdInput === null || requestParameters.replaceLoginIdInput === undefined) {
            throw new runtime.RequiredError('replaceLoginIdInput','Required parameter requestParameters.replaceLoginIdInput was null or undefined when calling changeUserLoginId.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters.sapCommerceCloudCustomerId !== undefined && requestParameters.sapCommerceCloudCustomerId !== null) {
            headerParameters['sap-commerce-cloud-customer-id'] = String(requestParameters.sapCommerceCloudCustomerId);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2_authorization_code", ["basic"]);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2_client_credentials", ["extended"]);
        }

        const response = await this.request({
            path: `/{baseSiteId}/users/{userId}/login`.replace(`{${"baseSiteId"}}`, encodeURIComponent(String(requestParameters.baseSiteId))).replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ReplaceLoginIdInputToJSON(requestParameters.replaceLoginIdInput),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Changes a customer\'s login id. Requires the customer\'s current password. This endpoint is added in the 2211.23 update.
     * Changes customer\'s login id.
     */
    async changeUserLoginId(requestParameters: ChangeUserLoginIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.changeUserLoginIdRaw(requestParameters, initOverrides);
    }

    /**
     * Updates the password of a customer. This endpoint is added in the 2211.23 update.
     * Updates the password of a customer.
     */
    async changeUserPasswordRaw(requestParameters: ChangeUserPasswordRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.baseSiteId === null || requestParameters.baseSiteId === undefined) {
            throw new runtime.RequiredError('baseSiteId','Required parameter requestParameters.baseSiteId was null or undefined when calling changeUserPassword.');
        }

        if (requestParameters.userId === null || requestParameters.userId === undefined) {
            throw new runtime.RequiredError('userId','Required parameter requestParameters.userId was null or undefined when calling changeUserPassword.');
        }

        if (requestParameters.replacePasswordInput === null || requestParameters.replacePasswordInput === undefined) {
            throw new runtime.RequiredError('replacePasswordInput','Required parameter requestParameters.replacePasswordInput was null or undefined when calling changeUserPassword.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters.sapCommerceCloudCustomerId !== undefined && requestParameters.sapCommerceCloudCustomerId !== null) {
            headerParameters['sap-commerce-cloud-customer-id'] = String(requestParameters.sapCommerceCloudCustomerId);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2_authorization_code", ["basic"]);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2_client_credentials", ["extended"]);
        }

        const response = await this.request({
            path: `/{baseSiteId}/users/{userId}/password`.replace(`{${"baseSiteId"}}`, encodeURIComponent(String(requestParameters.baseSiteId))).replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ReplacePasswordInputToJSON(requestParameters.replacePasswordInput),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Updates the password of a customer. This endpoint is added in the 2211.23 update.
     * Updates the password of a customer.
     */
    async changeUserPassword(requestParameters: ChangeUserPasswordRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.changeUserPasswordRaw(requestParameters, initOverrides);
    }

    /**
     * Registers a customer. Requires the following parameters: login, password, firstName, lastName, titleCode, verificationTokenId, verificationTokenCode. Only when OTP for registration is enabled, verificationTokenId and verificationTokenCode are required.
     *  Registers a customer.
     */
    async createUserRaw(requestParameters: CreateUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<User>> {
        if (requestParameters.baseSiteId === null || requestParameters.baseSiteId === undefined) {
            throw new runtime.RequiredError('baseSiteId','Required parameter requestParameters.baseSiteId was null or undefined when calling createUser.');
        }

        if (requestParameters.userSignUp === null || requestParameters.userSignUp === undefined) {
            throw new runtime.RequiredError('userSignUp','Required parameter requestParameters.userSignUp was null or undefined when calling createUser.');
        }

        const queryParameters: any = {};

        if (requestParameters.fields !== undefined) {
            queryParameters['fields'] = requestParameters.fields;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/xml';

        if (requestParameters.sapCommerceCloudCaptchaToken !== undefined && requestParameters.sapCommerceCloudCaptchaToken !== null) {
            headerParameters['sap-commerce-cloud-captcha-token'] = String(requestParameters.sapCommerceCloudCaptchaToken);
        }

        if (requestParameters.sapCommerceCloudCustomerId !== undefined && requestParameters.sapCommerceCloudCustomerId !== null) {
            headerParameters['sap-commerce-cloud-customer-id'] = String(requestParameters.sapCommerceCloudCustomerId);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2_authorization_code", ["basic"]);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2_client_credentials", ["extended"]);
        }

        const response = await this.request({
            path: `/{baseSiteId}/users`.replace(`{${"baseSiteId"}}`, encodeURIComponent(String(requestParameters.baseSiteId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: UserSignUpToJSON(requestParameters.userSignUp),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UserFromJSON(jsonValue));
    }

    /**
     * Registers a customer. Requires the following parameters: login, password, firstName, lastName, titleCode, verificationTokenId, verificationTokenCode. Only when OTP for registration is enabled, verificationTokenId and verificationTokenCode are required.
     *  Registers a customer.
     */
    async createUser(requestParameters: CreateUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<User> {
        const response = await this.createUserRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieve the customer information by customer id.
     * Retrieve the customer information by customer id.
     */
    async getCustomerByCustomerIdRaw(requestParameters: GetCustomerByCustomerIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Principal>> {
        if (requestParameters.baseSiteId === null || requestParameters.baseSiteId === undefined) {
            throw new runtime.RequiredError('baseSiteId','Required parameter requestParameters.baseSiteId was null or undefined when calling getCustomerByCustomerId.');
        }

        if (requestParameters.customerId === null || requestParameters.customerId === undefined) {
            throw new runtime.RequiredError('customerId','Required parameter requestParameters.customerId was null or undefined when calling getCustomerByCustomerId.');
        }

        const queryParameters: any = {};

        if (requestParameters.customerId !== undefined) {
            queryParameters['customerId'] = requestParameters.customerId;
        }

        if (requestParameters.fields !== undefined) {
            queryParameters['fields'] = requestParameters.fields;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.sapCommerceCloudCustomerId !== undefined && requestParameters.sapCommerceCloudCustomerId !== null) {
            headerParameters['sap-commerce-cloud-customer-id'] = String(requestParameters.sapCommerceCloudCustomerId);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2_authorization_code", ["basic"]);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2_client_credentials", ["extended"]);
        }

        const response = await this.request({
            path: `/{baseSiteId}/users`.replace(`{${"baseSiteId"}}`, encodeURIComponent(String(requestParameters.baseSiteId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PrincipalFromJSON(jsonValue));
    }

    /**
     * Retrieve the customer information by customer id.
     * Retrieve the customer information by customer id.
     */
    async getCustomerByCustomerId(requestParameters: GetCustomerByCustomerIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Principal> {
        const response = await this.getCustomerByCustomerIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves detailed information about a specific user\'s profile.
     * Retrieves the customer profile.
     */
    async getUserRaw(requestParameters: GetUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<User>> {
        if (requestParameters.baseSiteId === null || requestParameters.baseSiteId === undefined) {
            throw new runtime.RequiredError('baseSiteId','Required parameter requestParameters.baseSiteId was null or undefined when calling getUser.');
        }

        if (requestParameters.userId === null || requestParameters.userId === undefined) {
            throw new runtime.RequiredError('userId','Required parameter requestParameters.userId was null or undefined when calling getUser.');
        }

        const queryParameters: any = {};

        if (requestParameters.fields !== undefined) {
            queryParameters['fields'] = requestParameters.fields;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.sapCommerceCloudCustomerId !== undefined && requestParameters.sapCommerceCloudCustomerId !== null) {
            headerParameters['sap-commerce-cloud-customer-id'] = String(requestParameters.sapCommerceCloudCustomerId);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2_authorization_code", ["basic"]);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2_client_credentials", ["extended"]);
        }

        const response = await this.request({
            path: `/{baseSiteId}/users/{userId}`.replace(`{${"baseSiteId"}}`, encodeURIComponent(String(requestParameters.baseSiteId))).replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UserFromJSON(jsonValue));
    }

    /**
     * Retrieves detailed information about a specific user\'s profile.
     * Retrieves the customer profile.
     */
    async getUser(requestParameters: GetUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<User> {
        const response = await this.getUserRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves a list of customer groups that a specific user belongs to.
     * Retrieves the customer groups.
     */
    async getUserCustomerGroupsRaw(requestParameters: GetUserCustomerGroupsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UserGroupList>> {
        if (requestParameters.baseSiteId === null || requestParameters.baseSiteId === undefined) {
            throw new runtime.RequiredError('baseSiteId','Required parameter requestParameters.baseSiteId was null or undefined when calling getUserCustomerGroups.');
        }

        if (requestParameters.userId === null || requestParameters.userId === undefined) {
            throw new runtime.RequiredError('userId','Required parameter requestParameters.userId was null or undefined when calling getUserCustomerGroups.');
        }

        const queryParameters: any = {};

        if (requestParameters.fields !== undefined) {
            queryParameters['fields'] = requestParameters.fields;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.sapCommerceCloudCustomerId !== undefined && requestParameters.sapCommerceCloudCustomerId !== null) {
            headerParameters['sap-commerce-cloud-customer-id'] = String(requestParameters.sapCommerceCloudCustomerId);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2_authorization_code", ["basic"]);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2_client_credentials", ["extended"]);
        }

        const response = await this.request({
            path: `/{baseSiteId}/users/{userId}/customergroups`.replace(`{${"baseSiteId"}}`, encodeURIComponent(String(requestParameters.baseSiteId))).replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UserGroupListFromJSON(jsonValue));
    }

    /**
     * Retrieves a list of customer groups that a specific user belongs to.
     * Retrieves the customer groups.
     */
    async getUserCustomerGroups(requestParameters: GetUserCustomerGroupsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UserGroupList> {
        const response = await this.getUserCustomerGroupsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Deletes the customer profile associated with the user identifier.
     * Deletes the customer profile.
     */
    async removeUserRaw(requestParameters: RemoveUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.baseSiteId === null || requestParameters.baseSiteId === undefined) {
            throw new runtime.RequiredError('baseSiteId','Required parameter requestParameters.baseSiteId was null or undefined when calling removeUser.');
        }

        if (requestParameters.userId === null || requestParameters.userId === undefined) {
            throw new runtime.RequiredError('userId','Required parameter requestParameters.userId was null or undefined when calling removeUser.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.sapCommerceCloudCustomerId !== undefined && requestParameters.sapCommerceCloudCustomerId !== null) {
            headerParameters['sap-commerce-cloud-customer-id'] = String(requestParameters.sapCommerceCloudCustomerId);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2_authorization_code", ["basic"]);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2_client_credentials", ["extended"]);
        }

        const response = await this.request({
            path: `/{baseSiteId}/users/{userId}`.replace(`{${"baseSiteId"}}`, encodeURIComponent(String(requestParameters.baseSiteId))).replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Deletes the customer profile associated with the user identifier.
     * Deletes the customer profile.
     */
    async removeUser(requestParameters: RemoveUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.removeUserRaw(requestParameters, initOverrides);
    }

    /**
     * Updates customer profile. Attributes not provided in the request body will be defined again (set to null or default).
     * Updates the customer profile.
     */
    async replaceUserRaw(requestParameters: ReplaceUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.baseSiteId === null || requestParameters.baseSiteId === undefined) {
            throw new runtime.RequiredError('baseSiteId','Required parameter requestParameters.baseSiteId was null or undefined when calling replaceUser.');
        }

        if (requestParameters.userId === null || requestParameters.userId === undefined) {
            throw new runtime.RequiredError('userId','Required parameter requestParameters.userId was null or undefined when calling replaceUser.');
        }

        if (requestParameters.user === null || requestParameters.user === undefined) {
            throw new runtime.RequiredError('user','Required parameter requestParameters.user was null or undefined when calling replaceUser.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/xml';

        if (requestParameters.sapCommerceCloudCustomerId !== undefined && requestParameters.sapCommerceCloudCustomerId !== null) {
            headerParameters['sap-commerce-cloud-customer-id'] = String(requestParameters.sapCommerceCloudCustomerId);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2_authorization_code", ["basic"]);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2_client_credentials", ["extended"]);
        }

        const response = await this.request({
            path: `/{baseSiteId}/users/{userId}`.replace(`{${"baseSiteId"}}`, encodeURIComponent(String(requestParameters.baseSiteId))).replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UserToJSON(requestParameters.user),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Updates customer profile. Attributes not provided in the request body will be defined again (set to null or default).
     * Updates the customer profile.
     */
    async replaceUser(requestParameters: ReplaceUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.replaceUserRaw(requestParameters, initOverrides);
    }

    /**
     * Changes a customer\'s login name. Requires the customer\'s current password. This endpoint is deprecated in the 2211.23 update and its deletion is planned. Please use the POST /{baseSiteId}/users/{userId}/login instead.
     * Changes customer\'s login name.
     */
    async replaceUserLoginRaw(requestParameters: ReplaceUserLoginRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.baseSiteId === null || requestParameters.baseSiteId === undefined) {
            throw new runtime.RequiredError('baseSiteId','Required parameter requestParameters.baseSiteId was null or undefined when calling replaceUserLogin.');
        }

        if (requestParameters.newLogin === null || requestParameters.newLogin === undefined) {
            throw new runtime.RequiredError('newLogin','Required parameter requestParameters.newLogin was null or undefined when calling replaceUserLogin.');
        }

        if (requestParameters.password === null || requestParameters.password === undefined) {
            throw new runtime.RequiredError('password','Required parameter requestParameters.password was null or undefined when calling replaceUserLogin.');
        }

        if (requestParameters.userId === null || requestParameters.userId === undefined) {
            throw new runtime.RequiredError('userId','Required parameter requestParameters.userId was null or undefined when calling replaceUserLogin.');
        }

        const queryParameters: any = {};

        if (requestParameters.newLogin !== undefined) {
            queryParameters['newLogin'] = requestParameters.newLogin;
        }

        if (requestParameters.password !== undefined) {
            queryParameters['password'] = requestParameters.password;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.sapCommerceCloudCustomerId !== undefined && requestParameters.sapCommerceCloudCustomerId !== null) {
            headerParameters['sap-commerce-cloud-customer-id'] = String(requestParameters.sapCommerceCloudCustomerId);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2_authorization_code", ["basic"]);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2_client_credentials", ["extended"]);
        }

        const response = await this.request({
            path: `/{baseSiteId}/users/{userId}/login`.replace(`{${"baseSiteId"}}`, encodeURIComponent(String(requestParameters.baseSiteId))).replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Changes a customer\'s login name. Requires the customer\'s current password. This endpoint is deprecated in the 2211.23 update and its deletion is planned. Please use the POST /{baseSiteId}/users/{userId}/login instead.
     * Changes customer\'s login name.
     */
    async replaceUserLogin(requestParameters: ReplaceUserLoginRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.replaceUserLoginRaw(requestParameters, initOverrides);
    }

    /**
     * Updates the password of a customer. This endpoint is deprecated in the 2211.23 update and its deletion is planned. Please use the POST /{baseSiteId}/users/{userId}/password instead.
     * Updates the password of a customer.
     */
    async replaceUserPasswordRaw(requestParameters: ReplaceUserPasswordRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.baseSiteId === null || requestParameters.baseSiteId === undefined) {
            throw new runtime.RequiredError('baseSiteId','Required parameter requestParameters.baseSiteId was null or undefined when calling replaceUserPassword.');
        }

        if (requestParameters._new === null || requestParameters._new === undefined) {
            throw new runtime.RequiredError('_new','Required parameter requestParameters._new was null or undefined when calling replaceUserPassword.');
        }

        if (requestParameters.old === null || requestParameters.old === undefined) {
            throw new runtime.RequiredError('old','Required parameter requestParameters.old was null or undefined when calling replaceUserPassword.');
        }

        if (requestParameters.userId === null || requestParameters.userId === undefined) {
            throw new runtime.RequiredError('userId','Required parameter requestParameters.userId was null or undefined when calling replaceUserPassword.');
        }

        const queryParameters: any = {};

        if (requestParameters._new !== undefined) {
            queryParameters['new'] = requestParameters._new;
        }

        if (requestParameters.old !== undefined) {
            queryParameters['old'] = requestParameters.old;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.sapCommerceCloudCustomerId !== undefined && requestParameters.sapCommerceCloudCustomerId !== null) {
            headerParameters['sap-commerce-cloud-customer-id'] = String(requestParameters.sapCommerceCloudCustomerId);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2_authorization_code", ["basic"]);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2_client_credentials", ["extended"]);
        }

        const response = await this.request({
            path: `/{baseSiteId}/users/{userId}/password`.replace(`{${"baseSiteId"}}`, encodeURIComponent(String(requestParameters.baseSiteId))).replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Updates the password of a customer. This endpoint is deprecated in the 2211.23 update and its deletion is planned. Please use the POST /{baseSiteId}/users/{userId}/password instead.
     * Updates the password of a customer.
     */
    async replaceUserPassword(requestParameters: ReplaceUserPasswordRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.replaceUserPasswordRaw(requestParameters, initOverrides);
    }

    /**
     * Updates customer profile. Only attributes provided in the request body will be changed.
     * Updates customer profile
     */
    async updateUserRaw(requestParameters: UpdateUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.baseSiteId === null || requestParameters.baseSiteId === undefined) {
            throw new runtime.RequiredError('baseSiteId','Required parameter requestParameters.baseSiteId was null or undefined when calling updateUser.');
        }

        if (requestParameters.userId === null || requestParameters.userId === undefined) {
            throw new runtime.RequiredError('userId','Required parameter requestParameters.userId was null or undefined when calling updateUser.');
        }

        if (requestParameters.user === null || requestParameters.user === undefined) {
            throw new runtime.RequiredError('user','Required parameter requestParameters.user was null or undefined when calling updateUser.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/xml';

        if (requestParameters.sapCommerceCloudCustomerId !== undefined && requestParameters.sapCommerceCloudCustomerId !== null) {
            headerParameters['sap-commerce-cloud-customer-id'] = String(requestParameters.sapCommerceCloudCustomerId);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2_authorization_code", ["basic"]);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2_client_credentials", ["extended"]);
        }

        const response = await this.request({
            path: `/{baseSiteId}/users/{userId}`.replace(`{${"baseSiteId"}}`, encodeURIComponent(String(requestParameters.baseSiteId))).replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: UserToJSON(requestParameters.user),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Updates customer profile. Only attributes provided in the request body will be changed.
     * Updates customer profile
     */
    async updateUser(requestParameters: UpdateUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateUserRaw(requestParameters, initOverrides);
    }

}
